import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { ErrorMessage } from '@sdir/utilities/lib/components';
import { Endorsement } from '@sdir/blueprint.aps/lib/components';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesVerifyEndorsementVerifyEndorsementDto as EndorsementDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { endorsementApi } from '../../../httpclient';
import { messages } from '../../../localization';

const EndorsementPage: React.FC = () => {
  const { uid } = useParams<{ uid: string }>();
  const [searchError, setSearchError] = useState(null);
  const [endorsement, setEndorsement] = useState<EndorsementDto>();

  useEffect(() => {
    endorsementApi
      .verifyEndorsement(uid)
      .then((response) => {
        if (response.status === 200) {
          setEndorsement(response.data);
        }
      })
      .catch((error) => {
        setSearchError(error);
        setEndorsement(undefined);
      });
  }, [uid]);

  return (
    <Wrapper>
      {endorsement && (
        <EndorsementWrapper translate="no">
          <Endorsement
            authority={endorsement?.authority || ''}
            issuingAuthority={endorsement?.issuingAuthority}
            certificateNr={endorsement?.certificateNumber || ''}
            endorsementNr={endorsement?.endorsementNumber || ''}
            dateOfBirth={endorsement?.seafarerDateOfBirth || ''}
            name={endorsement?.seafarerName || ''}
            defaultLang="en"
            positionList={[
              {
                position: endorsement?.title || '',
                limitations: [messages?.en?.['endorsement.limitation']],
              },
            ]}
            validDate={endorsement?.expiresAt || ''}
            isStcwF={endorsement?.regulationRefrence === 'STCW_F'}
            issuedDate={endorsement?.issuedAt}
            hideQr
            qrImageLoading={false}
            // eslint-disable-next-line max-len
            qrData={`${process.env.REACT_APP_VERIFY_URL}/endorsement/${endorsement?.certificateNumber}`}
            hideLanguageSelector
          />
        </EndorsementWrapper>
      )}
      {searchError && <ErrorMessage error={searchError} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 2em;
`;

const EndorsementWrapper = styled.div`
  p {
    margin: 0;
  }
`;

export default EndorsementPage;
